import { useEffect, useState } from 'react';

let loggedOnce = false;

/** La versión del backend desde `/api/health` (sin auth, sin envelope), para el sidebar. */
export function useVersion(): string {
  const [version, setVersion] = useState<string>('…');

  useEffect(() => {
    let cancelled = false;
    fetch('/api/health')
      .then((r) => r.json())
      .then((h: { version?: string }) => {
        if (cancelled) return;
        const v = h.version ?? 'unknown';
        setVersion(v);
        if (!loggedOnce) {
          loggedOnce = true;
          // biome-ignore lint/suspicious/noConsole: banner de versión intencional
          console.log(
            `%c🗂 fisto backoffice %c${v}`,
            'font-weight:bold',
            'font-weight:bold;color:#22d3ee',
          );
        }
      })
      .catch(() => {
        if (!cancelled) setVersion('unknown');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return version;
}
